<aig-modal class="aig-edit-iban" position="center" customMaxWidth="600px">
  <div body>
    <div class="u-p-8 u-pb-6">
      <div class="p-flexcc u-dir-col u-gap-30">
        <div class="aig-modal-cancel__logo">
          <img src="../../../../../assets/images/logos/logo.svg" alt="loog-AIG" width="100%" height="auto">
        </div>
        <p class="u-text-center u-color-secondary1 u-fs-18 u-fw-400">
          Para poder visualizar y modificar el campo IBAN, debes de introducir los cuatro números anteriores a los cuatro
          últimos ya mostrados en el campo.
        </p>
        
        <div class="p-flexcc u-gap-24 u-size-per-100">
          <div class="e-field u-size-per-50">
            <input class="e-field__input u-text-right" type="text" name="iban-number" id="iban-number" pattern="[0-9]{4}" inputmode="numeric" [(ngModel)]="digitsRequired" maxlength="4">
          </div>

          <div class="e-field u-size-per-50">
            <input class="e-field__input" type="number" name="iban-number" id="iban-number" [value]="lastDigits" disabled>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="u-px-8 u-pb-8 p-flexcc u-gap-24" buttons>
    <button type="button" class="aig-edit-iban__btn e-btn--secondary u-size-per-50 p-flexcc" (click)="clickHide()">
      Cancelar
    </button>
    <button type="button" class="aig-edit-iban__btn e-btn--primary u-size-per-50 p-flexcc" [disabled]="!checkIfCanChange() || digitsRequired.length > 4" (click)="acceptChange()">
      Aceptar
    </button>
  </div>
</aig-modal>
